/**
 * FileManagerPage
 *
 * Page wrapper for the FileManager component.
 */

import React from 'react';
import { FileManager } from '@/components/files/FileManager';

export const FileManagerPage: React.FC = () => {
  return <FileManager />;
};

export default FileManagerPage;
